import DatabaseService from "../services/database";
import Dependents from "./Dependents";

async function listMissingProcessBlockerDependents(pageNumber: number, selectedWorkorderId: any): Promise<any[]> {
    // console.log("listMissingProcessBlockerDependents for page " + pageNumber)

    let missing: any[] = [];
    let workorder = await DatabaseService.getInstance().getStoredWorkorderAsync(selectedWorkorderId);

    if (workorder?.pages?.length != null && workorder?.pages?.length > pageNumber - 1) {
        let questionsOnCurrentPage = workorder.pages[pageNumber - 1].sections.flatMap((x: any) => x.items);

        let mandatoryFieldIds: string[] = [];
        let processBlockerQuestions = questionsOnCurrentPage.filter((x: any) => x.itemType === 2 || x.itemType === 7);
        let activeProcessBlockerFound = false; // When there are multiple process blocker and one is one is missing dependents, we don't want to check other process blockers.
        processBlockerQuestions.forEach((question: any) => {
            if (!activeProcessBlockerFound) {
                if (question.isMandatory && isMissing(question)) {
                    missing.push(question);
                }
                else {
                    let hasDependentMatch = Dependents.checkDependentMatch(question);
                    if (hasDependentMatch === false) {
                        mandatoryFieldIds.push(...question.dependentHideItemIds);
                    } else if (hasDependentMatch === true) {
                        mandatoryFieldIds.push(...question.dependentShowItemIds);
                    }
                    if (mandatoryFieldIds.length > 0) {
                        activeProcessBlockerFound = true;
                    }
                }
            }
        });

        questionsOnCurrentPage.forEach(function (question: any) {
            if (question.isMandatory &&
                mandatoryFieldIds.includes(question.id) &&
                isMissing(question)) {
                missing.push(question);
            }
        });
    }

    return Promise.resolve(missing.map((x: any) => {
        return {
            pageNumber: pageNumber,
            id: x.id,
            name: x.label
        }
    }));
}

async function listMissingMandatoryQuestions(pageNumber: number, selectedWorkorderId: any): Promise<any[]> {
    // console.log("listMissingMandatoryQuestions for page " + pageNumber)
    let missing: any[] = [];
    let workorder = await DatabaseService.getInstance().getStoredWorkorderAsync(selectedWorkorderId);

    if (workorder?.pages?.length != null && workorder?.pages?.length > pageNumber - 1) {
        let questionsOnCurrentPage = workorder.pages[pageNumber - 1].sections.flatMap((x: any) => x.items);

        let ignoreFieldIds: string[] = [];

        var questionWithDependents = questionsOnCurrentPage.filter((x: any) => x.dependentMatchValues?.length > 0);
        questionWithDependents.forEach((question: any) => {
            let hasDependentMatch = Dependents.checkDependentMatch(question);
            if (hasDependentMatch === true) {
                ignoreFieldIds.push(...question.dependentHideItemIds);
            }
            else if (hasDependentMatch === false) {
                ignoreFieldIds.push(...question.dependentShowItemIds);
            }
        });

        questionsOnCurrentPage.forEach(function (question: any) {
            if (ignoreFieldIds.includes(question.id)) {
                // console.log("Skipping " + question.id);
                return;
            }

            if (question.isMandatory) {
                if (question.itemType == 7 && question.toVerifyItemId != null) {
                    // Handle verification only bar code
                    // console.log("Validating " + question.id + " as verification only bar code")
                    let enteredValue = question.answer?.text
                    let validValue = question.defaultValue?.text;
                    if (!question.isVerified && enteredValue != validValue) {
                        // console.log("Bar code value was '" + textValue + "' expected '" + validValue + "'");
                        missing.push(question);
                    }
                }
                else if (isMissing(question)) {
                    missing.push(question);
                }
            } else if (question.itemType == 21) { // Deviation is a special case. I contains a "sub question".
                let deviationValue = question.answer != null ? question.answer.deviation : question.defaultValue?.deviation;
                if (deviationValue === true) {
                    // If deviation active, all previous questions are not mandatory.
                    // We currently only do it for the active page, but it might be needed to do it for all pages. But that's a bigger task.
                    missing = [];

                    let deviationText = question.answer != null ? question.answer.text : question.defaultValue?.text;
                    if (deviationText == null || deviationText == "") {
                        missing.push(question);
                    }
                }
            }
        });
    }

    // console.log("Missing mandatory");
    // console.log(missing.map((x) => x.id));
    return Promise.resolve(missing.map((x: any) => {
        return {
            pageNumber: pageNumber,
            id: x.id,
            name: x.label
        }
    }));
}


function isMissing(question: any) {
    const EmptySignatureImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAADICAYAAAA0n5+2AAAAAXNSR0IArs4c6QAACfdJREFUeF7t1jERAAAIAzHq3zQmfgwCOuQYfucIECBAgAABAgRSgaVrxggQIECAAAECBE5geQICBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBAQWH6AAAECBAgQIBALCKwY1BwBAgQIECBAQGD5AQIECBAgQIBALCCwYlBzBAgQIECAAAGB5QcIECBAgAABArGAwIpBzREgQIAAAQIEBJYfIECAAAECBAjEAgIrBjVHgAABAgQIEBBYfoAAAQIECBAgEAsIrBjUHAECBAgQIEBAYPkBAgQIECBAgEAsILBiUHMECBAgQIAAAYHlBwgQIECAAAECsYDAikHNESBAgAABAgQElh8gQIAAAQIECMQCAisGNUeAAAECBAgQEFh+gAABAgQIECAQCwisGNQcAQIECBAgQEBg+QECBAgQIECAQCwgsGJQcwQIECBAgAABgeUHCBAgQIAAAQKxgMCKQc0RIECAAAECBASWHyBAgAABAgQIxAICKwY1R4AAAQIECBB441UAyZjmBxcAAAAASUVORK5CYII=";

    switch (question.itemType) {
        case 0: // Unknown
        case 1: // Text
        case 7: // Bar code
        case 12: // Comment
        case 16: // MeterData
            let textValue = question.answer ? question.answer.text : question.defaultValue?.text;
            return textValue == null || textValue === "";
        case 2: // YesNo
            return question.answer?.yesNo !== true && question.answer?.yesNo !== false && question.defaultValue?.yesNo !== true;
        case 15: // Checkbox
            let boolValue = (question.answer ? question.answer.yesNo : question.defaultValue?.yesNo) == true;
            return !boolValue;
        case 3: // Whole number
            let wholeNumberValue = question.answer ? question.answer.wholeNumber : question.defaultValue?.wholeNumber;
            return wholeNumberValue == null || wholeNumberValue === "";
        case 19: // Date production
            let productionDate = question.answer ? question.answer.wholeNumber : question.defaultValue?.wholeNumber;
            return productionDate == null || productionDate === "" || productionDate > new Date().getTime();
        case 4: // Decimal number
            let decimalNumberValue = question.answer ? question.answer.decimalNumber : question.defaultValue?.decimalNumber;
            return decimalNumberValue == null || decimalNumberValue === "";
        case 5: // Image
        case 8: // Camera
            let imagesValue = question.answer ? question.answer.images : question.defaultValue?.images;
            return imagesValue == null || imagesValue.length == 0;
        case 17: // Signature
            let cameraImageValue = question.answer ? question.answer.camera?.image : question.defaultValue?.camera?.image;
            return cameraImageValue == null || cameraImageValue === "" || cameraImageValue == EmptySignatureImage;
        case 6: // Drop down
            let dropDownValue = question.answer ? question.answer.DropList?.DropDownListSelected : question.defaultValue?.dropList?.dropDownListSelected;
            return dropDownValue == null || dropDownValue === "";
        case 22: // BarCodeWithVerification
            let barCodeWithVerification = question.answer ? question.answer.text : question.defaultValue?.text;
            return barCodeWithVerification == null || barCodeWithVerification === "";
        case 23: // BarCodeForVerification
            if (!question.defaultValue?.text) {
                return false; // Ignore field if no default value
            }
            let barCodeForVerification = question.answer ? question.answer.text : question.defaultValue?.text;
            return barCodeForVerification == null || barCodeForVerification === "";
        default:
            console.error(`setHasMissingValueForPage: itemType ${question.itemType} is unhandled`)
            break;
    }
}

export default { listMissingMandatoryQuestions, listMissingProcessBlockerDependents }
